import { render, staticRenderFns } from "./AppFab.vue?vue&type=template&id=0820e368&"
import script from "./AppFab.vue?vue&type=script&lang=js&"
export * from "./AppFab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports